import React from 'react'
import { Button } from 'react-bootstrap'

const TableReportRow = ({ subject, setShowReportDetail, setReport, generateActividadesPdf }) => {

    const countTickeos = () => {
        let completes = 0
        let incompletes = 0
        let absets = 0
        let assists = 0
        subject.permanencia.forEach((tickeo) => {
            if (tickeo.completo) {
                completes++
                assists++
            } else if (tickeo.completo === false) {
                incompletes++
                assists++
            } else {
                absets++
            }
        })
        return [completes, incompletes, absets, assists]
    }

    const [completes, incompletes, absets, assists] = countTickeos()

    const handleShowReportDetail = () => {
        setShowReportDetail(true)
        setReport(subject)
    }

    return (
        <tr>
            <td>{subject.nombre}</td>
            <td className='text-center'>{subject.grupo}</td>
            <td className='text-center'>{assists}</td>
            <td className='text-center'>{absets}</td>
            <td className='text-center'>{completes}</td>
            <td className='text-center'>{incompletes}</td>
            <td className='text-center text-nowrap'>
                <Button variant='blue' className='text-nowrap' onClick={handleShowReportDetail}>
                    Ver Más
                </Button>
                {generateActividadesPdf && (
                    <Button variant='blue' className='text-nowrap ms-2' onClick={() => generateActividadesPdf(subject.id)}>
                        Actividades PDF
                    </Button>
                )}
            </td>
        </tr>
    )
}

export default TableReportRow
